import React from 'react';

import {RowNumbered} from 'src/components/row-numbered';

import {TableHeader} from '@pb/kit-component-data-table-v2';
import {Group, Item} from '@pb/kit-component-group';


import type {ReactNode} from 'react';


type Props = {
    maxRowNumber: number,
    selection?: ReactNode,
    reserveSelectionSpace?: boolean,
    fullHeight?: boolean,
    children: ReactNode,
};

export const MainColumnHeader: React.FC<Props> = ({
    maxRowNumber, children, selection, fullHeight, reserveSelectionSpace = true,
}) => (
    <TableHeader indent="none" mainColumn={true} className="search-header">
        <Group gap="none" alignItems="center" style={fullHeight ? {height: '100%'} : undefined}>
            <RowNumbered maxRowNumber={maxRowNumber} placeholder={<strong>#</strong>}/>
            {reserveSelectionSpace ? (
                <div style={{width: 50}}>
                    {selection}
                </div>
            ) : null}
            <Item grow={1} align={fullHeight ? 'stretch' : undefined}>{children}</Item>
        </Group>
    </TableHeader>
);
